import { render, staticRenderFns } from "./ProductDisplay.vue?vue&type=template&id=6226b433&scoped=true&"
import script from "./ProductDisplay.vue?vue&type=script&lang=js&"
export * from "./ProductDisplay.vue?vue&type=script&lang=js&"
import style0 from "./ProductDisplay.vue?vue&type=style&index=0&id=6226b433&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6226b433",
  null
  
)

export default component.exports